import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let systemErrorsMountPromise = null;

export function initSystemErrorsViewFragment({ onMounted } = {}) {
  registerViewMount('admin-system-errors', () => mountSystemErrorsView(onMounted));
}

async function mountSystemErrorsView(onMounted) {
  if (document.getElementById('view-admin-system-errors')) return;
  if (systemErrorsMountPromise) return systemErrorsMountPromise;

  systemErrorsMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');

    await appendTrustedAdminViewFragment(host, '/admin-views/system-errors.html', 'Unable to load system errors view');
    onMounted?.();
  })();

  try {
    await systemErrorsMountPromise;
  } catch (error) {
    systemErrorsMountPromise = null;
    throw error;
  }
}
